import React, { useEffect, useState } from "react";
import "./conquistaCelebracao.css";

const ConquistaCelebracao = ({ aberta, onClose, conquista, nomeUsuario }) => {
  const [progresso, setProgresso] = useState(100);
  const [contador, setContador] = useState(7);

  useEffect(() => {
    if (!aberta || !conquista) {
      return;
    }

    const totalMs = 7000;
    const stepMs = 100;
    let elapsed = 0;

    setProgresso(100);
    setContador(7);

    const intervalId = setInterval(() => {
      elapsed += stepMs;
      const restante = totalMs - elapsed;

      if (restante <= 0) {
        setProgresso(0);
        setContador(0);
        clearInterval(intervalId);
        if (typeof onClose === "function") {
          onClose();
        }
      } else {
        setProgresso((restante / totalMs) * 100);
        setContador(Math.ceil(restante / 1000));
      }
    }, stepMs);

    return () => {
      clearInterval(intervalId);
    };
  }, [aberta, conquista, onClose]);

  const handleFecharClick = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  if (!aberta || !conquista) {
    return null;
  }

  const nome = nomeUsuario && nomeUsuario.trim() ? nomeUsuario : "você";
  const recompensaMoedas = conquista.recompensa_moedas ?? 0;

  return (
    <div className="conquista-celebracao-overlay">
      <div className="conquista-celebracao-confetti-layer confetti-top" />
      <div className="conquista-celebracao-confetti-layer confetti-bottom" />

      <div className="conquista-celebracao-modal">
        <div className="conquista-celebracao-medalha-wrapper">
          <img
            src={conquista.imagem_url}
            alt={conquista.titulo}
            className="conquista-celebracao-medalha"
          />
        </div>

        <h3 className="conquista-celebracao-titulo">
          Conquista desbloqueada!
        </h3>

        <p className="conquista-celebracao-texto-principal">
          Parabéns, <strong>{nome}</strong>! Você desbloqueou:
        </p>

        <p className="conquista-celebracao-nome-conquista">
          <strong>{conquista.titulo}</strong>
        </p>

        {conquista.descricao && (
          <p className="conquista-celebracao-descricao">
            {conquista.descricao}
          </p>
        )}

        {/* 🆕 CARD DE RECOMPENSA EM MOEDA */}
        {recompensaMoedas > 0 && (
          <div className="conquista-celebracao-recompensa">
            <img src="/moeda.png" alt="Moeda" className="conquista-celebracao-recompensa-icone" />
            <span>Ganhou {recompensaMoedas} moedas!</span>
          </div>
        )}

        <button
          type="button"
          className="conquista-celebracao-botao-fechar"
          onClick={handleFecharClick}
        >
          Fechar
        </button>

        <div className="conquista-celebracao-progress-wrapper">
          <div className="conquista-celebracao-progress-bar">
            <div
              className="conquista-celebracao-progress-bar-inner"
              style={{ width: `${progresso}%` }}
            />
          </div>
          <span className="conquista-celebracao-contador">
            Fecha em {contador}s
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConquistaCelebracao;